import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
import Link from "next/link";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ChannelListRow(_ref) {
  var item = _ref.item;
  var handleClick = useCallback(function (e) {
    if (!item.isAllowedRating) {
      e.preventDefault();
    }
  }, [item]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, styles.list, _defineProperty({}, styles.notAllowed, !item.isAllowedRating)),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.artwork,
        children: /*#__PURE__*/_jsx(CardArtwork, {
          item: item,
          className: styles.artworkInner,
          href: routes.channelDetail(item.id),
          linkAttr: {
            onClick: handleClick
          }
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.info,
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles.title,
          children: /*#__PURE__*/_jsx(Link, {
            href: routes.channelDetail(item.id),
            children: /*#__PURE__*/_jsx("a", {
              onClick: handleClick,
              children: item.name
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.genre,
          children: /*#__PURE__*/_jsx("span", {
            children: item.genres.map(function (genre) {
              return genre.name;
            }).join("/")
          })
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: item.description
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FavoriteButton, {
          listRow: true,
          metaId: item.id
        })
      })]
    })
  });
}